import axios from 'axios'
import { IEvents } from "../services/props"

const API = 'https://events.explorechania.gr/api'

export const axiosEvents = {

  async getEvents() {
    // const { data } = await axios.get(`https://rethymno-events.dotsoft.gr//api/el/events`)
    const { data } = await axios.get(`https://events.explorechania.gr/api/el/events/?limit=1000&client_id=8`)
    return data.events

  }

}